import { REDUX_API_GATEWAY_ACTIONS } from '../constants/apiGateWayConstant';

// intiate store constant
import STORE_INITIATE_VALUE from '../constants/initialstore';

export default (state = STORE_INITIATE_VALUE.REPORTS_DATA, action) => {
  switch (action.type) {
    case REDUX_API_GATEWAY_ACTIONS.GET_REPORTS_DATA_SUCCESS:
      if (action.payload === undefined || action.payload === null || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          reportsData: null,
        };
      }
      return {
        ...state,
        reportsData: action.payload.data[0].attributes,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/csvExport.js